<mh-card-user-thumbnail [action]="log" [titleKey]="'company_position'" [showUserTarget]="!isDeactivateInactiveUsers">
  <div class="action-detail" header>
    <ng-container *ngIf="!isReviewLog else headerTitle">
      <ng-container *ngIf="isReportLog">{{ ('logs.resources.reports.title' | translate)}}: <strong mhFindTranslate [language]="language" keyTranlsate="reportName"
        [translates]="log.changes.reportNameTranslates" [capitalize]="true"></strong></ng-container>
      <ng-container *ngIf="!isReportLog">{{ ('logs.actions.'+(log.request_method_name || log.requestMethodName) | translate)}}: <strong>{{ isDeactivateInactiveUsers && userTargetLabel ? userTargetLabel : ('logs.resources.' + (log.resource_name || log.resourceName) + '.title' | translate) }}</strong><strong *ngIf="isReviewResource && log.resourceId"> - {{ log.resourceId }}</strong></ng-container>
    </ng-container>
  </div>
  <ng-container body>
    <ng-container *ngIf="isSurveyDeleted">
      <ng-container *ngTemplateOutlet="deletedSurveyLog, context: { log: log }"></ng-container>
    </ng-container>
    <ng-container *ngIf="isSurveyReactivated">
      <ng-container *ngTemplateOutlet="reactivatedSurveyLog, context: { log: log }"></ng-container>
    </ng-container>
    <ng-container *ngIf="isAutomaticAlert">
      <ng-container *ngTemplateOutlet="automaticAlertLog, context: { log: log }"></ng-container>
    </ng-container>
    <ng-container *ngIf="isContractLog">
      <ng-container *ngTemplateOutlet="contractLog, context: { log: log }"></ng-container>
    </ng-container>
    <ng-container *ngIf="isMarkKnowledgeFound">
      <ng-container *ngTemplateOutlet="knowledgeFoundLog, context: { log: log }"></ng-container>
    </ng-container>
    <ng-container *ngIf="!isSurveyDeleted && !isSurveyReactivated && !isReportLog && !isAutomaticAlert && !isContractLog && !isMarkKnowledgeFound">
      {{'logs.changes_description' | translate}}:
      <ng-container
      *ngTemplateOutlet="log.category === 'CUSTOMIZE_CONFIG' ? changesDescription : 
      (log.resourceName === 'case_discard_proposal' ? changesDiscartedCases : 
      changesList); 
  context: { changes: log.changes, log: log }"
      >
      </ng-container>
    </ng-container>
    <ng-container *ngIf="isReportLog">
      <ng-container
        *ngTemplateOutlet="reportLog, context: { changes: log.changes, log: log, language: language }"
      >
      </ng-container>
    </ng-container>
  </ng-container>
</mh-card-user-thumbnail>

<ng-template #headerTitle>
  <ng-container *ngIf="isReviewLog">
    <ng-container *ngTemplateOutlet="headerReview"></ng-container>
  </ng-container>
  <ng-container *ngIf="isReviewManaged || isSurveyAnsweredDeleted">
    <ng-container *ngTemplateOutlet="manageAnsweredSurvey"></ng-container>
  </ng-container>
</ng-template>

<ng-template #headerReview>
  {{'logs.actions.replied' | translate}}: <strong>{{'logs.resources.' + log.resourceName + '.title' | translate}} - {{log.changes[0].review_id }}</strong>
</ng-template>

<ng-template #manageAnsweredSurvey>
  {{'logs.actions.'+ (isReviewManaged ? 'managed' : 'deleted') | translate}}: <strong>{{'logs.resources.answered_survey.title' | translate}} - {{log.changes[0].answered_survey_id}}</strong>
</ng-template>

<ng-template #changesDiscartedCases>
  <div [innerHtml]="'logs.resources.case_discard_proposal.discarted_case_type' | translate: { log }" ></div>
  <div [innerHtml]="'logs.resources.case_discard_proposal.discarted_case_title' | translate: { log: { log_content: { caseTitle: '<a href=\'' + log.log_content.link + '\'>' + log.log_content.caseTitle + '</a>' } } }" ></div>
  <div *ngIf="log.log_content.proposalCaseDiscardedDto?.reasonComment"  [innerHtml]="'logs.resources.case_discard_proposal.discarted_case_other' | translate: { log }" ></div>
  <div *ngIf="!log.log_content.proposalCaseDiscardedDto?.reasonComment"  [innerHtml]="'logs.resources.case_discard_proposal.discarted_case' | translate: { log, ReasonText }" ></div>
</ng-template>


<ng-template #changesDescription>
  <p *ngFor="let change of log.changes"> {{ change?.description }} </p>
</ng-template>

<ng-template #changesList
  let-changes="changes"
  let-log="log">
  <ul>
    <ng-container *ngFor="let change of changes">
      <li *ngIf="!EXCLUDED_FIELDS.includes(change?.name)">
        <ng-container *ngIf="change.actual?.translates && !isSentiment; else baseChange">
          <ng-template *ngTemplateOutlet="commonLog, context: { change, log, language }"></ng-template>
        </ng-container>
        <ng-template #baseChange>
          <ng-container *ngIf="log.resourceName !== 'review_reply' && change.name !== 'translation'; else translation">
            <ng-container *ngIf="isReviewManaged || isSurveyAnsweredDeleted || isReprocessSurvey || isSentiment || isSurveyDeleted; else base">
              <div *ngIf="isReviewManaged" [innerHtml]="'logs.actions.managed' | translate:{name: userManage, date: (dateManage | date:'dd-MM-y'), answeredId: surveyIdManage}"></div>
              <div *ngIf="isSurveyAnsweredDeleted" [innerHtml]="'logs.actions.deleted' | translate:{name: userManage, answeredId: surveyIdManage}"></div>
              <div *ngIf="isReprocessSurvey" [innerHtml]="'logs.actions.reprocessed' | translate: { surveyName: change.surveyTypeName, startDate: (change.startDate | date: 'dd-MM-y'), endDate: (change.endDate | date: 'dd-MM-y')  }"></div>
              <div *ngIf="isSurveyDeleted" [innerHtml]="'logs.actions.survey_deleted' | translate: { reason: change.reason?.reason, reasonComment: change.reasonComment }"></div>
              <div *ngIf="isSentiment">
                <ng-template *ngTemplateOutlet="sentimentLog, context: { change, log, language }"></ng-template>
              </div>
            </ng-container>
            <ng-template #base>
              {{'logs.resources.' + log.resourceName + '.fields.' + change.name | translate}}:
              <span
                [innerHtml]="('logs.changes.' + change.operation + '.' + change.type | translate: (getTranslateParam(change)))"
                >
              </span>
            </ng-template>
          </ng-container>
          <ng-template #translation>
            <ng-container *ngIf="log.resourceName !== 'review_reply' else translateReviewLog">
              {{'logs.resources.' + log.resourceName + '.fields.' + change.actual.fieldName | translate}}:
              <span
                [innerHtml]="('logs.changes.' + change.operation + '.' + change.type | translate: (getTranslateParamForTranslation(change)))"
                >
              </span>
            </ng-container>
          </ng-template>
          <ng-template #translateReviewLog>
              {{'logs.resources.' + log.resourceName + '.review_replied' | translate}}:
              <span>
                {{change.description}}
              </span>
          </ng-template>
        </ng-template>
      </li>
    </ng-container>
  </ul>
</ng-template>

<ng-template #sentimentLog let-change="change" let-log="log" let-language="language">
  <strong mhFindTranslate
    [language]="language"
    [translates]="change.actual?.translates"
    [keyTranlsate]="'text'"
    [capitalize]="true"
  ></strong>:
  <span
    [innerHtml]="('logs.changes.' + change.operation + '.' + change.type | translate: (getTranslateParam(change)))"
  ></span>
</ng-template>

<ng-template #commonLog let-change="change" let-log="log" let-language="language">
  {{'logs.resources.' + log.resourceName + '.fields.' + change.name | translate}}:
  <strong mhFindTranslate
    [language]="language"
    [translates]="change.actual?.translates"
    [keyTranlsate]="'name'"
    [capitalize]="true"
  ></strong>
</ng-template>

<ng-template #reportLog let-changes="changes" let-log="log" let-language="language">
  <ul>
    <li>
      <strong>{{'logs.resources.reports.download_date' | translate}}:</strong> {{changes.downloadDate | date:'dd-MM-y'}}
    </li>
    <li>
      <strong>{{'logs.resources.reports.name' | translate}}:</strong>
      <span mhFindTranslate [language]="language" keyTranlsate="reportName"
        [translates]="changes.reportNameTranslates" [capitalize]="true"></span>
    </li>
    <li>
      <strong>{{'logs.resources.reports.range' | translate}}:</strong>
      {{changes.reportRange.substring(1, 11) | date:'dd-MM-y'}} - {{changes.reportRange.substring(13, 23) | date:'dd-MM-y'}}
    </li>
    <li>
      <strong>{{'logs.resources.reports.customer' | translate}}:</strong> {{changes.customerData.customerName}}
    </li>
    <li>
      <strong>{{'logs.resources.reports.chain_id' | translate}}:</strong> {{changes.customerData.chainId}}
    </li>
    <li>
      <strong>{{'logs.resources.reports.user' | translate}}:</strong> {{changes.userData.userName}}
    </li>
    <li>
      <strong>{{'logs.resources.reports.user_id' | translate}}:</strong> {{changes.userData._id}}
    </li>
    <li>
      <strong>{{'logs.resources.reports.obtaining_by' | translate}}:</strong> {{changes.obtainingBy}}
    </li>
  </ul>
</ng-template>

<ng-template #reactivatedSurveyLog let-log="log">
  <p class="tw-text-sm tw-mb-2">{{'logs.changes_description' | translate}}:</p>

  <ul class="tw-text-sm tw-mb-0">
    <li>
      {{'logs.resources.reactivate_surveys.fields.reactivated_by' | translate}}: <b>{{log.user.complete_name}} ({{log.user.email}})</b>
    </li>
    <li>
      {{'logs.resources.reactivate_surveys.fields.reactivation_date' | translate}}: <b>{{log.log_content.reactivationDate | date:'d MMMM yyyy, HH:mm'}}</b>
    </li>
    <li>
      {{'logs.resources.reactivate_surveys.fields.survey_id' | translate}}: <b>{{log.log_content.answeredSurveyId}}</b>
    </li>
    <li>
      {{'logs.resources.reactivate_surveys.fields.answer_date' | translate}}: <b>{{log.log_content.answerDate | date:'d MMMM yyyy'}}</b>
    </li>
    <li>
      {{'logs.resources.reactivate_surveys.fields.origin_name' | translate}}: <b>{{log.log_content.originName || '-'}}</b>
    </li>
    <li>
      {{'logs.resources.reactivate_surveys.fields.nps' | translate}}: <b>{{log.log_content.nps || '-'}}</b>
    </li>
  </ul>
</ng-template>

<ng-template #deletedSurveyLog let-log="log">
  <p class="tw-text-sm tw-mb-2">{{'logs.changes_description' | translate}}:</p>

  <ul class="tw-text-sm tw-mb-0">
    <li>
      {{'logs.resources.delete_surveys.fields.deleted_by' | translate}}: <b>{{log.user.complete_name}} ({{log.user.email}})</b>
    </li>
    <li>
      {{'logs.resources.delete_surveys.fields.deletion_date' | translate}}: <b>{{log.log_content.deletionDate | date:'d MMMM yyyy, HH:mm'}}</b>
    </li>
    <li>
      {{'logs.resources.delete_surveys.fields.survey_id' | translate}}: <b>{{log.log_content.answerId}}</b>
    </li>
    <li>
      {{'logs.resources.delete_surveys.fields.answer_date' | translate}}: <b>{{(log.log_content.answerDate || log.log_content.creationDate) | date:'d MMMM yyyy'}}</b>
    </li>
    <li>
      {{'logs.resources.delete_surveys.fields.origin_name' | translate}}: <b>{{log.log_content.originName || '-'}}</b>
    </li>
    <li>
      {{'logs.resources.delete_surveys.fields.nps' | translate}}: <b>{{log.log_content.nps || '-'}}</b>
    </li>
    <li>
      {{'logs.resources.delete_surveys.fields.delete_reason' | translate}}: <b>{{deleteReasonText || '-'}}</b>
    </li>
    <li>
      {{'logs.resources.delete_surveys.fields.delete_comment' | translate}}: <b>{{log.log_content.deletionReason?.reasonComment || '-'}}</b>
    </li>
  </ul>
</ng-template>

<ng-template #automaticAlertLog let-log="log">
  <p class="tw-text-sm tw-mb-2">{{'logs.changes_description' | translate}}:</p>

  <ul class="tw-text-sm tw-mb-0">
    <li>
      {{'logs.resources.automatic-alert.fields.transition_applied' | translate}}: <b>{{log.log_content.transitionApplied}}</b>
    </li>
    <li>
      {{'logs.resources.automatic-alert.fields.rule_description' | translate}}: <b>{{log.log_content.ruleDescription}}</b>
    </li>
    <li>
      {{'logs.resources.automatic-alert.fields.alert_id' | translate}}: <b>{{log.log_content.alertSnapshot?.activeAlertId}}</b>
    </li>
    <li>
      {{'logs.resources.automatic-alert.fields.alert_description' | translate}}: <b>{{log.log_content.alertSnapshot?.alertDescription}}</b>
    </li>
    <li>
      {{'logs.resources.automatic-alert.fields.unpaid_not_due' | translate}}: <b>{{log.log_content.totalUnpaidNotDueInvoices}}</b>
    </li>
    <li>
      {{'logs.resources.automatic-alert.fields.unpaid_overdue' | translate}}: <b>{{log.log_content.totalUnpaidOverdueInvoices}}</b>
    </li>
    <li *ngIf="log.log_content.alertSnapshot?.productsInvolved?.length">
      {{'logs.resources.automatic-alert.fields.products_involved' | translate}}: 
      <b>{{log.log_content.alertSnapshot.productsInvolved.join(', ')}}</b>
    </li>
  </ul>
</ng-template>

<ng-template #contractLog let-log="log">
  <p class="tw-text-sm tw-mb-2">{{'logs.changes_description' | translate}}:</p>

  <ul class="tw-text-sm tw-mb-0">
    <li>
      {{'logs.resources.customer_contracts.fields.action' | translate}}: 
      <b>
        <ng-container *ngIf="isContractDownload">{{'logs.resources.customer_contracts.actions.download' | translate}}</ng-container>
        <ng-container *ngIf="isContractDelete">{{'logs.resources.customer_contracts.actions.delete' | translate}}</ng-container>
        <ng-container *ngIf="isContractUpload">{{'logs.resources.customer_contracts.actions.upload' | translate}}</ng-container>
      </b>
    </li>
    <li>
      {{'logs.resources.customer_contracts.fields.file_name' | translate}}: <b>{{log.log_content?.file_name || '-'}}</b>
    </li>
    <li *ngIf="log.log_content?.file_key">
      {{'logs.resources.customer_contracts.fields.file_key' | translate}}: <b>{{log.log_content.file_key}}</b>
    </li>
    <li *ngIf="log.log_content?.created">
      {{'logs.resources.customer_contracts.fields.file_date' | translate}}: <b>{{log.log_content.created | date:'d MMMM yyyy HH:mm'}}</b>
    </li>
    <li *ngIf="log.log_content?.customer_id">
      {{'logs.resources.customer_contracts.fields.customer_id' | translate}}: <b>{{log.log_content.customer_id}}</b>
    </li>
    <li *ngIf="log.log_content?.path_folder">
      {{'logs.resources.customer_contracts.fields.path_folder' | translate}}: <b>{{log.log_content.path_folder}}</b>
    </li>
    <li *ngIf="log.log_content?.uploader_user_id">
      {{'logs.resources.customer_contracts.fields.uploader_user' | translate}}: <b>{{log.log_content.uploader_user_id}}</b>
    </li>
    <li *ngIf="log.log_content?.id">
      {{'logs.resources.customer_contracts.fields.file_id' | translate}}: <b>{{log.log_content.id}}</b>
    </li>
  </ul>
</ng-template>

<ng-template #knowledgeFoundLog let-log="log">
  <p class="tw-text-sm tw-mb-2">{{'logs.changes_description' | translate}}:</p>

  <ul class="tw-text-sm tw-mb-0">
    <li>
      {{'logs.resources.update_chat_message_knowledge_found.fields.input_message' | translate}}: <b>{{log.log_content?.inputMessage || '-'}}</b>
    </li>
    <li>
      {{'logs.resources.update_chat_message_knowledge_found.fields.concierge_answer' | translate}}: <b>{{log.log_content?.conciergeAnswer || '-'}}</b>
    </li>
    <li>
      {{'logs.resources.update_chat_message_knowledge_found.fields.chat_message_id' | translate}}: <b>{{log.log_content?.chatMessageId || '-'}}</b>
    </li>
  </ul>
</ng-template>
